import { render, staticRenderFns } from "./FilterContainer.vue?vue&type=template&id=57134736&scoped=true&"
import script from "./FilterContainer.vue?vue&type=script&lang=js&"
export * from "./FilterContainer.vue?vue&type=script&lang=js&"
import style0 from "./FilterContainer.vue?vue&type=style&index=0&id=57134736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57134736",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57134736')) {
      api.createRecord('57134736', component.options)
    } else {
      api.reload('57134736', component.options)
    }
    module.hot.accept("./FilterContainer.vue?vue&type=template&id=57134736&scoped=true&", function () {
      api.rerender('57134736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalFilter/FilterContainer.vue"
export default component.exports